import { useState } from "react";
import {
  DrawerBody,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { useBrandHasModule } from "utils/currentUserHooks";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { Module } from "__generated__/gql/graphql";
import { LabeledValueContextProvider } from "components/Shared/LabeledValue";
import SkuDetailsTab from "./DetailsTab";
import CustomersTab from "./CustomersTab";
import ProductMappings from "./Mappings";

const fragment = gql(/* GraphQL */ `
  fragment SkuPanelView on Sku {
    id
    name
    isArchived
    ...SkuDetailsTab
  }
`);

type Props = {
  sku: FragmentType<typeof fragment> | null | undefined;
  isLoading?: boolean;
};

export default function SkuPanelView({ sku: skuFragment, isLoading }: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const sku = getFragmentData(fragment, skuFragment);
  const hasAnalytics = useBrandHasModule(Module.ANALYTICS);

  return (
    <DrawerBody pb={10}>
      <LabeledValueContextProvider isLoading={isLoading}>
        <Tabs
          index={activeTab}
          onChange={setActiveTab}
          colorScheme="lightPinkButton"
          isLazy
        >
          <TabList>
            <Tab>Details</Tab>
            <Tab>Customers</Tab>
            {hasAnalytics && <Tab>Mappings</Tab>}
          </TabList>
          <TabPanels>
            <TabPanel px={0}>
              <SkuDetailsTab sku={sku} />
            </TabPanel>

            <TabPanel px={0}>
              <CustomersTab skuId={sku?.id} />
            </TabPanel>

            {hasAnalytics && (
              <TabPanel px={0}>
                <ProductMappings skuId={sku?.id} />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </LabeledValueContextProvider>
    </DrawerBody>
  );
}
